// extracted by mini-css-extract-plugin
export default {"pageWrap":"PptPreview_pageWrap__a1u8w","pageBtn":"PptPreview_pageBtn__xM0mY"};